interface IPurchaseOrderStatus {
  id: string;
  title: string;
  description?: string;
  status: "success" | "error" | "info";
  chart: boolean;
}

export const PURCHASE_ORDER_STATUS: IPurchaseOrderStatus[]  = [
    {
      id: 'INITIALIZED',
      title: "Iniciado",
      description: "El cliente seleccionó los tickets e inicio la compra en la plataforma de pago.",
      status: "info",
      chart: false,
    },
    {
      id: 'PAYMENT_FAILED',
      title: "Pago fallido",
      description: "Hubo un error al realizar el pago de los tickets.",
      status: "error",
      chart: false,
    },
    {
      id: 'TRANSFER_PAYMENT_CREATED',
      title: "Pendiente de validación",
      description: "Se debe revisar el capture para generar los tickets.",
      status: "info",
      chart: true,
    },
    {
      id: 'PURCHASE_ORDER_REJECTED',
      title: "Orden rechazada",
      description: "Se rechazó la orden de compra.",
      status: "error",
      chart: true,
    },
    {
      id: 'PAYMENT_SUCCESSFUL',
      title: "Pago exitoso",
      description: "El proceso de pago en la plataforma de pago fue exitoso.",
      status: "success",
      chart: true,
    },
    {
      id: 'PURCHASE_ORDER_CANCELED',
      title: "Tickets cancelados",
      description: "Se cancelaron los tickets y se liberaron los números.",
      status: "error",
      chart: true,
    },
    {
      id: 'CASH_PAYMENT_BAD_CREDENTIALS',
      title: "Error al validar credenciales",
      description: "Al momento de generar los tickets de la rifa el usuario ingresó una clave errónea.",
      status: "success",
      chart: false,
    },
    {
      id: 'SENDING_MAIL_ERROR',
      title: "Error email",
      description: "Hubo un error al realizar enviar el email.",
      status: "error",
      chart: true,
    },
    {
      id: 'PROCESS_FINISHED',
      title: "Proceso finalizado",
      description: "El proceso completo de compra ha sido finzalizado, los tickets han sido enviados por correo al email indicado en la compra.",
      status: "success",
      chart: true,
    },
    {
      id: 'PROCESS_INITIALIZED',
      title: "Proceso iniciado",
      description: "Los tickets se están generando, recuerde que el proceso puede demorar de 1 a 5 minutos.",
      status: "info",
      chart: false,
    },
  
];

export const PURCHASE_ORDER_STATUS_V2: IPurchaseOrderStatus[]  = [
  {
    id: 'TRANSFER_PAYMENT_CREATED',
    title: "Pendiente de validación",
    description: "Se debe revisar el capture para generar los tickets.",
    status: "info",
    chart: true,
  },
  {
    id: 'PURCHASE_ORDER_REJECTED',
    title: "Orden rechazada",
    description: "Se rechazó la orden de compra.",
    status: "error",
    chart: true,
  },
  {
    id: 'SENDING_MAIL_ERROR',
    title: "Error email",
    description: "Hubo un error al realizar enviar el email. Los tickets fueron enviados.",
    status: "error",
    chart: true,
  },
  {
    id: 'PROCESS_FINISHED',
    title: "Proceso finalizado",
    description: "Los tickets han sido enviados por correo al email indicado en la compra.",
    status: "success",
    chart: true,
  },
];